<script>
import draggable from 'vuedraggable'
import {
    isNumberStr,
    dateTimeFormat,
    dateTypeOptions,
    dateRangeTypeOptions,
    defaultActiveData
} from '@/utils/rightBoard'
import RulesDialog from './RulesDialog.vue'
import DateDaysDialog from './DateDaysDialog.vue'
import ComputeDialog from './ComputeDialog.vue'
import TreeNodeDialog from './TreeNodeDialog.vue'
import AssignmentDialog from './AssignmentDialog.vue'
import CodeRulesTable from './CodeRulesTable.vue'
import { transOperator, getAction, downloadFileBlob, normalRegular, isValidRegex, isPersonalInfoInput } from '@/utils/tools'
export default {
    name: 'right',
    props: {
        form: {
            type: Object,
            default: () => {}
        },
        selectItem: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        RulesDialog,
        DateDaysDialog,
        ComputeDialog,
        CodeRulesTable
    },
    data() {
        return {
            currentTab: 'field',
            iconsVisible: false,
            currentIconModel: null,
            upLoadDialogVisible: false,
            activeData: defaultActiveData,
            assignmentDialogVisible: false,
            rulesDialogVisible: false,
            treeNodeDialogVisible: false,
            cascaderData: {},
            currentNode: [],
            areaList: [],
            dictTypeList: [],
            viewList: [],
            eventCodeList: [], //任务表单-选择业务
            relTaskList: [], //任务表单-关联任务字段
            voluationList: [], //任务表单-赋值规则字段
            showComputeDialog: false,
            slider: [25, 75]
        }
    },
    methods: {
        eventCodeSelected(eventCode) {
            if (!eventCode) return
            // 获取关联任务字段
            const { api } = this.$attrs.option
            if (api.getShowFormItemsByEventCode) {
                const [action, params] = getAction(api.getShowFormItemsByEventCode)
                action({ eventCode, ...params }).then((res) => {
                    const { data } = res
                    this.relTaskList = data || []
                })
            }
            // 获取视图
            if(api.getEventViewPage) {
                const [action, params] = getAction(api.getEventViewPage)
                action({ eventCode, pageNum: 1, pageSize: 99, ...params }).then(res => {
                    const { data: { list } } = res
                    this.viewList = list
                })
            }
            // 获取关联任务-赋值规则
            if(api.getMainFormItemsByEventCode) {
                const [action, params] = getAction(api.getMainFormItemsByEventCode)
                action({ eventCode, ...params }).then((res) => {
                    const { data } = res
                    this.voluationList = data || []
                })
            }
        }
    },
    watch: {
        selectItem: {
            handler(value) {
                if(!value) return
                this.activeData = value

                // 回显相关
                const { api } = this.$attrs.option
                const { activeData } = this
                // const eventCodeSelected = eventCode => {
                //     if (!eventCode) return
                //     // 获取关联任务字段
                //     const { api } = this.$attrs.option
                //     if (api.getShowFormItemsByEventCode) {
                //         api.getShowFormItemsByEventCode({ eventCode }).then((res) => {
                //             const { data } = res
                //             this.relTaskList = data || []
                //         })
                //     }
                // }
                const getEventCodeList = () => {
                    if(api.getEventListByPage) {
                        const [action, params] = getAction(api.getEventListByPage)
                        action({pageNum: 1, pageSize: 99, category: "NORMAL", status: 2, ...params}).then(res => {
                            const { data: { list } } = res
                            if (!list && !Array.isArray(list)) return;
                            this.eventCodeList = list
                        })
                    }
                }
                if(activeData.typeId === 'ByDictSelect') {
                    // 字典下拉框
                    if(api.getAllDictType) {
                        const [action, params] = getAction(api.getAllDictType)
                        action(params).then((res) => {
                            this.dictTypeList = res.data
                        })
                    }
                }
                if(activeData.typeId === 'DESIGN_SUBTABLE') {
                    if(this.eventCodeList.length) return
                    getEventCodeList()
                    const { eventCode } = activeData
                    eventCode && this.eventCodeSelected(eventCode)
                }
                if(activeData.typeId === 'TREE_RELATION') {
                    if (this.viewList.length) return
                    const { eventCode } = this.$attrs
                    activeData.eventCode = eventCode
                    activeData.idField = "id"
                    // 获取视图
                    if(eventCode && api.getEventViewPage) {
                        const [action, params] = getAction(api.getEventViewPage)
                        action({ eventCode, pageNum: 1, pageSize: 99, ...params }).then(res => {
                            const { data: { list } } = res
                            this.viewList = list
                        })
                    }
                }
                if(activeData.typeId === 'BIZ_RELATION') {
                    if(this.eventCodeList.length) return
                    getEventCodeList()
                    const { eventCode } = activeData
                    eventCode && this.eventCodeSelected(eventCode)
                }
                if(activeData.typeId === 'TASK_FORM') {
                    // 任务表单中下拉框回显
                    const { eventCode } = this.$attrs
                    if (this.viewList.length && this.relTaskList.length) return
                    eventCode && this.eventCodeSelected(eventCode)
                    if(this.eventCodeList.length) return
                    getEventCodeList()
                }
                if(activeData.typeId === 'AREA_CODE') {
                    let maxLevel
                    if(value.level) {
                        const [start, end] = value.level
                        this.slider = [start * 25, end * 25]
                        maxLevel = start
                    } else {
                        this.activeData = {
                            ...value,
                            checkStrictly: 0,
                            level: [3, 4],
                            rangeArr: [["33", "3304"]]
                        }
                        this.slider = [75, 125]
                        maxLevel = 3
                    }
                    const {option: { api: { getDictOptionTree } }} = this.$attrs
                    if(!getDictOptionTree) return
                    const [ action ] = getAction(getDictOptionTree)
                    action({ maxLevel }).then((res) => {
                        this.areaList = res.data || []
                    })
                }
            },
            immediate: true,
            deep: true
        }
    },
    render(h) {
        const { activeData } = this
        // 一些方法
        const setDefaultValue = val => {
            if (Array.isArray(val)) {
                if (val.every((e) => typeof e === "string")) {
                    return val.join(",")
                } else {
                    if (this.activeData.__config__.label === "部门") {
                        return val.map((e) => e.deptName).join(",")
                    } else {
                        return JSON.stringify(val)
                    }
                }
            }
            if (typeof val === "boolean") {
                return `${val}`
            }
            return val
        }
        const onDefaultValueInput = str => {
            if (Array.isArray(this.activeData.__config__.defaultValue)) {
                // 数组
                this.$set(
                    this.activeData.__config__,
                    "defaultValue",
                    str.split(",").map((val) => (isNumberStr(val) ? +val : val))
                )
            } else if (["true", "false"].indexOf(str) > -1) {
                // 布尔
                this.$set(this.activeData.__config__, "defaultValue", JSON.parse(str))
            } else {
                // 字符串和数字
                this.$set(
                    this.activeData.__config__,
                    "defaultValue",
                    isNumberStr(str) ? +str : str
                )
            }
        }
        // icon对话框
        const openIconsDialog = () => {} // 之后迁移
        // 时间
        const setTimeValue = (val, type) => {
            const valueFormat = type === "week" ? dateTimeFormat.date : val
            this.$set(this.activeData.__config__, "defaultValue", null)
            this.$set(this.activeData, "value-format", valueFormat)
            this.$set(this.activeData, "format", val)
        }
        const dateOptions = () => {
            if (
                this.activeData &&
                this.activeData.type !== undefined &&
                this.activeData.__config__.tag === "el-date-picker"
            ) {
                if (this.activeData["start-placeholder"] === undefined) {
                    return dateTypeOptions
                }
                return dateRangeTypeOptions
            }
            return []
        }
        // 下拉选择
        const addSelectItem = () => {
            const _opts = this.activeData.__slot__ ? this.activeData.__slot__.options : this.activeData.options
            _opts.push({ label: "", value: ""})
        }
        const handleSave = () => {
            const {option: { api: { exportData } }} = this.$attrs
            if(exportData) {
                exportData().then((res) => {
                    downloadFileBlob(res, "导入数据模版");
                })
            }
        }
        const handleUploadOption = () => {
            this.$refs['upload'].clearFiles()
            this.$refs['upload'].$refs['upload-inner'].handleClick()
        }
        const handleSliderChange = (val) => {
            const [start, end] = val
            const level = [start / 25, end / 25]
            this.activeData.level = level
            const {option: { api: { getDictOptionTree } }} = this.$attrs
            if(!getDictOptionTree) return
            const [ action ] = getAction(getDictOptionTree)
            action({ maxLevel: start / 25 }).then((res) => {
                this.areaList = res.data || []
            })
        }
        const formItemList = this.form.design.formItems
            .filter(item => ["INPUT", "SELECT", "SELECT_V2", "TEXTAREA", "OrgTreeSelect", "org-user-picker"].includes(item.typeId))
            .map((obj) => {
                return {
                    code: obj.__vModel__,
                    name: obj.__config__.label,
                }
            })
        const allFormItem = this.form.design.formItems.filter(item => item.typeId !== 'INPUT_COMPUTED').map((obj) => {
            return {
                code: obj.__vModel__,
                name: obj.__config__.label,
            }
        })
        const taskNameList = this.form.design.formItems.filter(item => !["INFO_FEEDBACK", "TASK_FORM"].includes(item.typeId))
        const setCalculationRules = calculationRules => {
            this.$set(this.activeData, 'calculationRules', calculationRules)
        }
        const setBizAssignmentRules = bizAssignmentRules => {
            this.$set(this.activeData, 'bizAssignmentRules', bizAssignmentRules)
        }
        const computedText = (arr) => {
            let str = '' 
            arr.map(item => {
                str = str + ` ${item.label} ${item.operator ? transOperator(item.operator) : ''}`
            })
            return str
        }
        const addTabs = () => {
            const length = this.activeData.props.tabs.length
            this.activeData.props.tabs.push({
                label: `标签${length + 1}`,
                index: length - 1,
                rows: []
            })
        }
        const delTabs = index => {
            this.activeData.props.tabs.splice(index, 1)
        }
        const __vModel__ = (
            <el-form-item label="组件ID">
                <el-input v-model={ activeData.__vModel__ }></el-input>
            </el-form-item>
        )
        const componentName = (
            <el-form-item label="组件ID">{ activeData.__config__.componentName }</el-form-item>
        )
        const label = (
            <el-form-item label="标题">
                <el-input v-model={activeData.__config__.label} placeholder="请输入标题"></el-input>
            </el-form-item>
        )
        const placeholder = (
            <el-form-item label="占位提示">
                <el-input v-model={activeData.placeholder} placeholder="请输入占位提示" />
            </el-form-item>
        )
        const startPlaceholder = (
            <el-form-item label="开始占位">
                <el-input v-model={ activeData['start-placeholder'] } placeholder="请输入占位提示" />
            </el-form-item>
        ) 
        const endPlaceholder = (
            <el-form-item label="结束占位">
                <el-input v-model={ activeData['end-placeholder'] } placeholder="请输入占位提示" />
            </el-form-item>
        )
        const span = (
            <el-form-item label="表单栅格">
                <el-slider v-model={ activeData.__config__.span }  marks={{12: ''}} max={24} min={8} />
            </el-form-item>
        )
        const defaultValue = (
            <el-form-item label="默认值">
                <el-input 
                    value={setDefaultValue(activeData.__config__.defaultValue)}
                    placeholder="请输入默认值"
                    onInput={str => onDefaultValueInput(str)}
                />
            </el-form-item>
        )
        const checkboxMin = (
            <el-form-item label="至少应选">
                <el-input-number min={0} v-model={activeData.min} />
            </el-form-item>
        )
        const checkboxMax = (
            <el-form-item label="最多可选">
                <el-input-number min={0} v-model={activeData.max} />
            </el-form-item>
        )
        const slotPrepend =  activeData.typeId === 'INPUT' ? (
            <el-form-item label="前缀">
                <el-input v-model={activeData.__slot__.prepend} placeholder="请输入前缀" />
            </el-form-item>
        ) : null
        
        const slotAppend = activeData.typeId === 'INPUT' ? (
            <el-form-item label="后缀">
                <el-input v-model={activeData.__slot__.append} placeholder="请输入后缀" />
            </el-form-item>
        ) : null
        const prefixIcon = (
            <el-form-item label="前图标">
                <el-input v-model={activeData['prefix-icon']} placeholder="请输入前图标名称">
                    <el-button slot="append" icon="el-icon-thumb" onClick={() => openIconsDialog('prefix-icon')}>选择</el-button>
                </el-input>
            </el-form-item>
        )
        const suffixIcon = (
            <el-form-item label="后图标">
                <el-input v-model={activeData['suffix-icon']} placeholder="请输入后图标名称">
                    <el-button slot="append" icon="el-icon-thumb" onClick={() => openIconsDialog('suffix-icon')}>选择</el-button>
                </el-input>
            </el-form-item>
        )
        const icon = (
            <el-form-item label="按钮图标">
                <el-input v-model={activeData.icon} placeholder="请输入按钮图标名称">
                    <el-button slot="append" icon="el-icon-thumb" onClick={() => openIconsDialog('icon')}>选择</el-button>
                </el-input>
            </el-form-item>
        )
        const minRows = activeData.autosize?.minRows ? (
            <el-form-item label="最小行数">
                <el-input-number v-model={activeData.autosize.minRows} min={1} placeholder="最小行数" />
            </el-form-item>
        ) : null
        const maxRows = activeData.autosize?.maxRows ? (
            <el-form-item label="最大行数">
                <el-input-number v-model={activeData.autosize.maxRows} min={1} placeholder="最大行数" />
            </el-form-item>
        ) : null
        const min = (
            <el-form-item label="最小值"><el-input-number v-model={activeData.min} placeholder="最小值" /></el-form-item>
        )
        const max = (
            <el-form-item label="最大值"><el-input-number v-model={activeData.max} placeholder="最大值" /></el-form-item>
        )
        const step = (
            <el-form-item label="步长">
                <el-input-number v-model={activeData.step} placeholder="步数" />
            </el-form-item>
        )
        const precision = (
            <el-form-item label="精度">
                <el-input-number v-model={activeData.precision} min={0} placeholder="精度" />
            </el-form-item>
        )
        const controlsPosition = (
            <el-form-item label="按钮位置">
                <el-radio-group v-model={activeData['controls-position']}>
                    <el-radio-button label=""> 默认</el-radio-button>
                    <el-radio-button label="right"> 右侧</el-radio-button>
                </el-radio-group>
            </el-form-item>
        )
        const maxlength = (
            <el-form-item label="最多输入">
                <el-input v-model={activeData.maxlength} placeholder="请输入字符长度" scopedSlots={{append: () => '个字符'}} />
            </el-form-item>
        )
        const dateType = (
            <el-form-item label="时间类型">
                <el-select
                    v-model={activeData.type}
                    style="width: 100%"
                    placeholder="请选择时间类型"
                    onChange={val => setTimeValue(dateTimeFormat[val], val)}
                >
                {
                    dateOptions().map((item, index) => {
                        return (
                            <el-option key={index} label={item.label} value={item.value} />
                        )
                    })
                }
                </el-select>
            </el-form-item>
        )
        const fileSize = (
            <el-form-item label="文件大小">
                <el-input v-model={activeData.__config__.fileSize} placeholder="请输入文件大小">
                    <el-select slot="append" v-model={activeData.__config__.sizeUnit} style="width: '66px'">
                        <el-option label="KB" value="KB" />
                        <el-option label="MB" value="MB" />
                        <el-option label="GB" value="GB" />
                    </el-select>
                </el-input>
            </el-form-item>
        )
        // listType废弃2025/12/12
        // const listType = (
        //     <el-form-item label="列表类型">
        //         <el-radio-group v-model={activeData['list-type']} size="small">
        //             <el-radio-button label="text"> text</el-radio-button>
        //             <el-radio-button label="picture"> picture</el-radio-button>
        //         </el-radio-group>
        //     </el-form-item>
        // )
        const buttonText = (
            <el-form-item label="按钮文字">
                <el-input v-model={activeData.__config__.buttonText} placeholder="请输入按钮文字" />
            </el-form-item>
        )
        const rangeSeparator = (
            <el-form-item label="分隔符">
                <el-input v-model={ activeData['range-separator'] } placeholder="请输入分隔符" />
            </el-form-item>
        )
        const format = (
            <el-form-item label="时间格式">
                <el-input value={activeData.format} placeholder="请输入时间格式" onInput={value => setTimeValue(value)} />
            </el-form-item>
        )
        // SELECT_V2
        const options = (
            <div>
                <el-divider>选项</el-divider>
                <draggable animation={340} list={activeData.options} group="selectItem" handle=".option-drag">
                    {
                        activeData.options?.map((item, index) => {
                            return (
                                <div key={index} class="select-item">
                                    <div class="select-line-icon option-drag"><i class="el-icon-s-operation" /></div>
                                    <el-input v-model={item.label} placeholder="选项名" onInput={value => item.value = value} size="small" />
                                    <div class="close-btn select-line-icon" onClick={() => activeData.options.splice(index, 1)}>
                                        <i class="el-icon-remove-outline" />
                                    </div>
                                </div>
                            )
                        })
                    }
                </draggable>
                <div style="margin-left: 20px; margin-bottom: 20px">
                    <el-button onClick={() => addSelectItem()} icon="el-icon-circle-plus-outline" type="text" style="padding-bottom: 0">添加选项</el-button>
                    <el-button onClick={() => handleSave()} type="text" style="padding-bottom: 0">下载模版</el-button>
                    <el-tooltip effect="dark" content="导入数据需严格按照模版规范" placement="right">
                        <el-button onClick={() => handleUploadOption() } type="text" style="padding-bottom: 0">导入数据</el-button>
                    </el-tooltip>
                </div>
            </div>
        )
        // CHECKBOX
        const slotOptions = (
            <div>
                <el-divider>选项</el-divider>
                <draggable animation={340} list={activeData.__slot__?.options} group="selectItem" handle=".option-drag">
                    {
                        activeData.__slot__?.options?.map((item, index) => {
                            return (
                                <div key={index} class="select-item">
                                    <div class="select-line-icon option-drag"><i class="el-icon-s-operation" /></div>
                                    <el-input v-model={item.label} placeholder="选项名" onInput={value => item.value = value} size="small" />
                                    <div class="close-btn select-line-icon" onClick={() => activeData.__slot__.options.splice(index, 1)}>
                                        <i class="el-icon-remove-outline" />
                                    </div>
                                </div>
                            )
                        })
                    }
                </draggable>
                <div style="margin-left: 20px; margin-bottom: 20px">
                    <el-button onClick={() => addSelectItem()} icon="el-icon-circle-plus-outline" type="text" style="padding-bottom: 0">添加选项</el-button>
                    <el-button onClick={() => handleSave()} type="text" style="padding-bottom: 0">下载模版</el-button>
                    <el-tooltip effect="dark" content="导入数据需严格按照模版规范" placement="right">
                        <el-button onClick={() => handleUploadOption() } type="text" style="padding-bottom: 0">导入数据</el-button>
                    </el-tooltip>
                </div>
            </div>
        )
        const optionType = (
            <el-form-item label="选项样式">
                <el-radio-group v-model={activeData.__config__.optionType}>
                    <el-radio-button label="default">默认</el-radio-button>
                    <el-radio-button label="button">按钮</el-radio-button>
                </el-radio-group>
            </el-form-item>
        )
        const showLabel = (
            <el-form-item label="显示标签">
                <el-switch v-model={activeData.__config__.showLabel} />
            </el-form-item>
        )
        const range = (
            <el-form-item label="范围选择">
                <el-switch v-model={activeData.range} 
                    onChange={value => {
                        this.activeData.__config__.defaultValue = value ? [this.activeData.min, this.activeData.max] : this.activeData.min
                    }} 
                />
            </el-form-item>
        )
        const showWordLimit = (
            <el-form-item label="输入统计">
                <el-switch v-model={activeData['show-word-limit']} />
            </el-form-item>
        )
        const checkStrictly = (
            <el-form-item label="数据层级">
                <el-radio-group v-model={activeData.checkStrictly}>
                    <el-radio label={1}>全部</el-radio>
                    <el-radio label={0}>仅末级</el-radio>
                </el-radio-group>
                <div class="block">
                    <el-slider
                        onChange={value => handleSliderChange(value)}
                        range
                        min={25}
                        max={150}
                        show-tooltip={false}
                        v-model={this.slider}
                        step={25}
                        marks={{
                            25: "省份",
                            50: "地市",
                            75: "区县",
                            100: "镇街",
                            125: "村社",
                            150: {
                                style: {
                                    width: "30px",
                                },
                                label: "网格",
                            }
                        }}
                    />
                </div>
            </el-form-item>
        )
        const rangeArr = (
            <el-form-item label="数据范围">
                {
                    h('el-cascader', {
                        props: {
                            value: this.activeData.rangeArr,
                            options: this.areaList,
                            props: {
                                checkStrictly: true,
                                label: 'name',
                                value: 'code',
                                children: 'child',
                                multiple: true
                            },
                            clearable: true,
                            'show-all-levels': false
                        },
                        attrs: {
                            placeholder: '请选择'
                        },
                        on: {
                            input: (value) => {
                                this.activeData.rangeArr = value
                                }
                            }
                        })
                }
            </el-form-item>
        )
        const multiple = (
            <el-form-item label="是否多选">
                <el-switch v-model={activeData.multiple} />
            </el-form-item>
        )
        const showAllLevels = (
            <el-form-item label="展示全路径">
                <el-switch v-model={activeData['show-all-levels']} />
            </el-form-item>
        )
        const filterable = (
            <el-form-item label="可否筛选">
                <el-switch v-model={activeData.filterable} />
            </el-form-item>
        )
        const clearable = (
            <el-form-item label="能否清空">
                <el-switch v-model={activeData.clearable} />
            </el-form-item>
        )
        const showTip = (
            <el-form-item label="显示提示">
                <el-switch v-model={activeData.__config__.showTip} />
            </el-form-item>
        )
        const limit = (
            <el-form-item label="文件个数">
                <el-input-number v-model={activeData.limit} />
            </el-form-item>
        )
        const required = (
            <el-form-item label="是否必填">
                <el-switch v-model={activeData.__config__.required} />
            </el-form-item>
        )
        const mobileCopy = (
            <el-form-item label="移动端复制">
                <el-switch v-model={activeData.copy} />
            </el-form-item>
        )
        const isUnique = (
            <el-form-item label="是否唯一键">
                <el-switch v-model={activeData.__config__.isUnique} />
            </el-form-item>
        )
        const isCascader = (
            <el-form-item label="是否级联">
                <el-switch v-model={activeData.__config__.isCascader} />
            </el-form-item>
        )
        const stepStrictly = (
            <el-form-item label="严格步数">
                <el-switch v-model={activeData['step-strictly']} />
            </el-form-item>
        )
        const textAlign = (
            <el-form-item label="对齐方式">
                <el-radio-group v-model={activeData.textAlign}>
                    <el-radio-button label="left"> 左对齐</el-radio-button>
                    <el-radio-button label="center"> 居中</el-radio-button>
                    <el-radio-button label="right"> 右对齐</el-radio-button>
                </el-radio-group>
            </el-form-item>
        )
        const encryptWord = activeData.props?.word ? (
            <el-form-item label="脱敏位数">
                <el-input v-model={activeData.props.word} placeholder="请输入" />
            </el-form-item>
        ) : null
        const encryptRule = activeData.props?.rule ? (
            <el-form-item label="脱敏方式">
                <el-radio-group v-model={activeData.props.rule} size="mini">
                    <el-radio-button label="front">前</el-radio-button>
                    <el-radio-button label="center">中</el-radio-button>
                    <el-radio-button label="after">后</el-radio-button>
                </el-radio-group>
            </el-form-item>
        ) : null
        const maxSelect = (
            <el-form-item label="最多可选数">
                <el-input-number step-strictly={true} min={1} v-model={activeData.max} /> 
            </el-form-item>
        )
        const dictType = (
            <el-form-item label="字典类型">
                <el-select placeholder="请选择字典类型" v-model={activeData.dictType}>
                    {
                        this.dictTypeList.map(item => <el-option key={item.id} value={item.dictType} label={item.dictName} />)
                    }
                </el-select>
            </el-form-item>
        )
        const activeText = (
            <el-form-item label="开启提示">
                <el-input v-model={activeData['active-text']} placeholder="请输入开启提示" />
            </el-form-item>
        )
        const inactiveText = (
            <el-form-item label="关闭提示">
                <el-input v-model={activeData['inactive-text']} placeholder="请输入关闭提示" />
            </el-form-item>
        )
        const showStops = (
            <el-form-item label="显示间断点">
                <el-switch v-model={activeData['show-stops']} />
            </el-form-item>
        )
        const pickerOptions = activeData['picker-options']?.selectableRange ? (
            <el-form-item label="时间段">
                <el-input v-model={activeData['picker-options'].selectableRange} placeholder="请输入时间段" />
            </el-form-item>
        ) : null
        const allowHalf = (
            <el-form-item label="允许半选">
                <el-switch v-model={activeData['allow-half']} />
            </el-form-item>
        )
        const showText = (
            <el-form-item label="辅助文字">
                <el-switch v-model={activeData['show-text']} />
            </el-form-item>
        )
        const showScore = (
            <el-form-item label="显示分数">
                <el-switch v-model={activeData['show-score']} />
            </el-form-item>
        )
        const calculate = (
            <el-form-item label="计算规则">
                <DateDaysDialog
                    checks={activeData.checks}
                    onChecks={data => this.$set(activeData, 'checks', data)}
                    workingDate={activeData.workingDate}
                    onWorkingDate={data => this.$set(activeData, 'workingDate', data)}
                    has-work-time={activeData.hasWorkTime}
                    onHasWorkTime={data => this.$set(activeData, 'hasWorkTime', data)}
                    attrs={this.$attrs}
                />
            </el-form-item>
        )
        const unit = (
            <el-form-item label="单位">
                <el-select placeholder="请选择字典类型" v-model={activeData.unit}>
                    <el-option value="day" label="天" />
                    <el-option value="hour" label="小时" />
                </el-select>
            </el-form-item>
        )
        const viewCode = (
            <el-form-item label="视图">
                <el-select v-model={activeData.viewCode} style="{ width: '100%' }" placeholder="请选择视图">
                    {
                        this.viewList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const nameField = (type) => {
            let children = null
            if(type === 'father') {
                children = formItemList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            } else if (type === 'relation') {
                children = this.relTaskList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            }
            return  (
                <el-form-item label="主字段">
                    <el-select v-model={activeData.nameField} placeholder="请选择主字段">
                        { children }
                    </el-select>
                </el-form-item>
            )
        }
        const descField = (type) => {
            let children = null
            if(type === 'father') {
                children = formItemList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            } else if (type === 'relation') {
                children = this.relTaskList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            }
            return (
                <el-form-item label="副字段">
                    <el-select v-model={activeData.descField} placeholder="请选择副字段" multiple>
                        { children }
                    </el-select>
                </el-form-item>
            )
        }
        const eventCode = (
            <el-form-item label="选择业务">
                <el-select v-model={activeData.eventCode} placeholder="请选择业务" onChange={eventCode => this.eventCodeSelected(eventCode)}>
                    {
                        this.eventCodeList.map((item, index) => {
                            return <el-option key={index} label={item.eventName} value={item.eventCode} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const idField = (
            <el-form-item label="ID字段">
                <el-select v-model={activeData.idField} placeholder="请选择Id字段">
                    {
                        this.relTaskList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const taskFormMore = (
            <el-form-item label="是否允许填写多份" label-width="130px">
                <el-switch v-model={activeData.more} />
            </el-form-item>
        )
        const startViewCode = (
            <el-form-item label="发起视图">
                <el-select v-model={activeData.startViewCode} placeholder="请选择视图">
                    {
                        this.viewList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const writeViewCode = (
            <el-form-item label="填报视图">
                <el-select v-model={activeData.writeViewCode} placeholder="请选择视图">
                    {
                        this.viewList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const taskCode = (
            <el-form-item label="关联任务字段" label-width="100px">
                <el-select v-model={activeData.taskCode} placeholder="请选择任务字段">
                    {
                        this.relTaskList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const taskName = (
            <el-form-item label="关联任务名称" label-width="100px">
                <el-select v-model={activeData.taskName} placeholder="请选择任务名称">
                    {
                        taskNameList.map((item, index) => {
                            return <el-option key={index} label={item.__config__.label} value={item.__vModel__} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const isAssignment = (
            <el-form-item label="是否赋值">
                <el-radio-group v-model={activeData.isAssignment}>
                    <el-radio label={true}>是</el-radio>
                    <el-radio label={false}>否</el-radio>
                </el-radio-group>
            </el-form-item>
        )
        const assignmentType = activeData.isAssignment ? (
            <el-form-item label="赋值规则">
                <el-button type="text" 
                    onClick={() => {
                        this.assignmentDialogVisible = true
                    }}  
                >配置</el-button>
            </el-form-item>    
        ) : undefined
        const previewBtnName = (
            <el-form-item label="查看按钮名称" label-width="100px">
                <el-input v-model={activeData.previewBtnName} placeholder="请输入去查看按钮名称" />
            </el-form-item>
        )
        const fillBtnName = (
            <el-form-item label="填报按钮名称" label-width="100px">
                <el-input v-model={activeData.fillBtnName} placeholder="请输入去填报按钮名称" />
            </el-form-item>
        )
        const computedDialog = (
            <el-form-item label="计算表达式">
                <el-button type="text" onClick={() => this.showComputeDialog = true}>配置</el-button>
            </el-form-item>
        )
        const computedLabel = activeData.calculationRules?.operator ? (
            <el-form-item label="计算方式">
                <span style="color: red">{computedText(activeData.calculationRules.operator)}</span>
            </el-form-item>
        ) : null
        const uploadApi = (
            <el-form-item label="上传文件路径" label-width="100px">
                <el-input v-model={activeData.action} placeholder="请输入上传文件路径" />
            </el-form-item>
        )
        const FeedbackOptions = (
            <div>
                <el-divider>默认回复内容</el-divider>
                <draggable animation={340} list={activeData.options} group="selectItem" handle=".option-drag">
                    {
                        activeData.options?.map((item, index) => {
                            return (
                                <div key={index} class="select-item">
                                    <div class="select-line-icon option-drag"><i class="el-icon-s-operation" /></div>
                                    <el-input v-model={item.label} placeholder="请输入默认回复内容" maxlength="20" onInput={value => item.value = value} size="small" />
                                    <div class="close-btn select-line-icon" onClick={() => activeData.options.splice(index, 1)}>
                                        <i class="el-icon-remove-outline" />
                                    </div>
                                </div>
                            )
                        })
                    }
                </draggable>
                <div style="margin-left: 20px; margin-bottom: 20px">
                    <el-button onClick={() => addSelectItem()} icon="el-icon-circle-plus-outline" type="text" style="padding-bottom: 0">添加回复内容</el-button>
                </div>
            </div>
        )
        const readonly = (
            <el-form-item label="是否只读">
                <el-switch v-model={activeData.readonly} />
            </el-form-item>
        )
        const inputReadonly = (
            <el-form-item label="是否只读">
                <el-switch v-model={activeData.disabled} />
            </el-form-item>
        )
        const append = (data, type) => {
            if (type && type === "edit") {
                this.cascaderData = data;
            } else {
                const _formData = { label: "", value: "" }
                if (this.activeData.isData) _formData.extraValue = ""
                this.cascaderData = _formData
            }
            if (type === "edit") {
                this.currentNode = data
            } else {
                if (!data.children) this.$set(data, "children", [])
                this.currentNode = data.children
            }
            this.treeNodeDialogVisible = true
        }
        const remove = (node, data) => {
            activeData.__config__.defaultValue = [] // 避免删除时报错
            const { parent } = node
            const children = parent.data.children || parent.data
            const index = children.findIndex((d) => d.id === data.id)
            children.splice(index, 1)
            if (!children.length) delete parent.data.children
        }
        const renderContent = (h, { node, data }) => {
            return (
                <div class="custom-tree-node">
                    <span title={node.label}>{node.label}</span>
                    <span class="node-operation">
                        <i on-click={() => append(data)}
                            class="el-icon-plus"
                            title="添加"
                        ></i>
                        <i on-click={() => append(data, "edit")}
                            class="el-icon-edit"
                            title="编辑"
                        ></i>
                        <i on-click={() => remove(node, data)}
                            class="el-icon-delete"
                            title="删除"
                        ></i>
                    </span>
                </div>
            )
        }
        const addTreeItem = () => {
            this.treeNodeDialogVisible = true
            this.cascaderData = { label: '', value: '' }
            this.currentNode = activeData.options;
        }
        const cascaderOption = (
            <div>
                <el-divider>选项</el-divider>
                <el-tree 
                    data={activeData.options}
                    expand-on-click-node={false}
                    draggable={true}
                    node-key="id"
                    render-content={renderContent}
                />
                <div style="margin-left: 20px">
                    <el-button
                        icon="el-icon-circle-plus-outline"
                        type="text"
                        onClick={addTreeItem}
                    >
                        添加父级
                    </el-button>
                </div>
                <el-divider></el-divider>
            </div> 
        )
        const addNode = data => {
            if(Array.isArray(this.currentNode)) {
                this.currentNode.push(data)
            }
        }
        // 编码组件 - 编码规则
        const codeRules = (
            <div>
                <el-divider>编码规则</el-divider>
                <CodeRulesTable 
                    key={activeData.__vModel__}
                    ruleList={activeData.ruleList}
                    onCodeRules={codeRules => {
                        const { ruleList, example } = codeRules
                        this.$set(activeData, 'ruleList', ruleList)
                        this.$set(activeData, 'example', example)
                    }}
                />
            </div>
        )
        // 单行 多行文本 - 校验规则
        const validateRules = isPersonalInfoInput(activeData.__config__.label) ? null : (
            <el-form-item label="校验规则">
                <el-select
                    placeholder="请选择" 
                    v-model={activeData.__config__.validateRules}
                    onChange={value => this.$set(activeData.__config__, 'regular', value)}
                >
                    {
                        normalRegular.map(item => <el-option key={item.name} value={item.pattern} label={item.name} />)
                    }
                </el-select>
            </el-form-item>
        )
        // 单行 多行文本 - 正则表达式
        const regular = isPersonalInfoInput(activeData.__config__.label) ? null : (
            <el-form-item label="正则表达式">
                <el-input 
                    v-model={activeData.__config__.regular} 
                    onBlur={event => {
                        const value = event.target.value
                        console.log(isValidRegex(value))
                        if(!isValidRegex(value)) {
                            this.$message.error('请输入正确的正侧表达式')
                            return
                        } 
                    }} 
                    placeholder="请输入正则表达式" 
                />
            </el-form-item>
        )
        // 单行 多行文本 - 错误信息
        const errorMessage = isPersonalInfoInput(activeData.__config__.label) ? null : (
            <el-form-item label="错误信息">
                <el-input v-model={activeData.__config__.errorMessage} placeholder="请输入错误信息" />
            </el-form-item>
        )
        // 单行 多行文本 - 是否脱敏
        const isDesensitization = (
            <el-form-item label="是否脱敏">
                <el-switch v-model={activeData.__config__.isDesensitization} />
            </el-form-item>
        )
        // 单行 多行文本 - 脱敏规则
        const desensitizationRule = (
            <el-form-item label="脱敏规则">
                <el-select
                        placeholder="请选择" 
                        v-model={activeData.__config__.desensitizationRule}
                        onChange={value => {}}
                >
                    <el-option value="PHONE" label="手机号脱敏" />
                    <el-option value="ID_CARD" label="身份证脱敏" />
                    <el-option value="BANK_CARD" label="银行卡脱敏" />
                    <el-option value="EMAIL" label="邮箱脱敏" />
                    <el-option value="NAME" label="中文名脱敏" />
                    <el-option value="ADDRESS" label="地址脱敏" />
                    <el-option value="CUSTOM" label="自定义脱敏(展示前m后n)" />
                </el-select>
            </el-form-item>
        )
        // 单行 多行文本 - 数据库脱敏
        const isDataBaseDesensitization = (
            <el-form-item label="数据库脱敏">
                <el-switch v-model={activeData.__config__.isDataBaseDesensitization} />
            </el-form-item>
        )
        const customDesensitizationConf = activeData.__config__.desensitizationRule === 'CUSTOM' ? (
            <div>
                <el-form-item label="脱敏配置m">
                    {
                        h('el-input', {
                            attrs: {
                                placeholder: '请输入'
                            },
                            model: {
                                value: activeData.__config__.prefixCus,
                                callback: value => this.$set(activeData.__config__, 'prefixCus', Number(value))
                            },
                            on: {
                                input: value => this.$set(activeData.__config__, 'prefixCus', Number(value))
                            }
                        })
                    }
                </el-form-item>
                <el-form-item label="脱敏配置n">
                    {
                        h('el-input', {
                            attrs: {
                                placeholder: '请输入'
                            },
                            model: {
                                value: activeData.__config__.suffixCus,
                                callback: value => this.$set(activeData.__config__, 'suffixCus', Number(value))
                            },
                            on: {
                                input: value => this.$set(activeData.__config__, 'suffixCus', Number(value))
                            }
                        })
                    }
                </el-form-item>
            </div>
        ) : null
        const appSaasUrl = (
            <el-form-item label="appSaasUrl">
                <el-input v-model={activeData.appSaasUrl} placeholder="请输入" type="textarea" rows={2}/>
            </el-form-item>
        )
        const propsTitle = activeData.props?.title ? title => (
                    <el-form-item label={title}>
                        <el-input v-model={activeData.props.title} placeholder={`请输入${title}`} />
                    </el-form-item>
        ) : () => {}
        const shadow = activeData.props?.shadow ? (
            <el-form-item label="显示阴影">
                <el-radio-group v-model={activeData.props.shadow} size="mini">
                    <el-radio-button label="always">一直</el-radio-button>
                    <el-radio-button label="hover">移入</el-radio-button>
                    <el-radio-button label="never">永不</el-radio-button>
                </el-radio-group>
            </el-form-item>
        ) : null
        const tabsType = activeData.props?.type ? (
            <el-form-item label="风格类型">
                <el-radio-group v-model={activeData.props.type} size="mini">
                    <el-radio-button label="">默认</el-radio-button>
                    <el-radio-button label="card">选项卡</el-radio-button>
                    <el-radio-button label="border-card">卡片化</el-radio-button>
                </el-radio-group>
            </el-form-item>
        ) : null
        const tabPosition = activeData.props?.tabPosition ? (
            <el-form-item label="选项卡位置">
                <el-radio-group v-model={activeData.props.tabPosition} size="mini">
                    <el-radio-button label="top">顶部</el-radio-button>
                    <el-radio-button label="left">左</el-radio-button>
                    <el-radio-button label="right">右</el-radio-button>
                    <el-radio-button label="bottom">底部</el-radio-button>
                </el-radio-group>
            </el-form-item>
        ) : null
        const tabConfig = activeData.props?.tabs ? (
            <div>
                <el-divider>标签页配置</el-divider>
                {
                    activeData.props.tabs?.map((item, index) => {
                        return (
                            <div key={index} style="display: flex; align-items: center; padding: 5px 0;">
                                <el-input size="small" v-model={item.label} placeholder="请输入标签标题" style="width: 80%;" />
                                {
                                    index === activeData.props.tabs.length - 1 ? <i onClick={addTabs} class="el-icon-circle-plus" style="padding: 0 5px; font-size: 20px; cursor: pointer; color: #409EFF"></i> : null
                                }
                                <i onClick={() => delTabs(index)} class="el-icon-delete" style="padding: 0 5px; font-size: 20px; cursor: pointer; color: #409EFF"></i>
                            </div>
                        )
                    })
                }
            </div>
        ) : null
        const accordion = activeData.props ? ( 
            <el-form-item label="是否手风琴">
              <el-switch v-model={activeData.props.accordion} />
            </el-form-item>
        ) : null
        const titlePosition = activeData.props?.position ? (
            <el-form-item label="对齐方式">
              <el-radio-group v-model={activeData.props.position} size="mini">
                <el-radio-button label="left">左对齐</el-radio-button>
                <el-radio-button label="center">居中</el-radio-button>
                <el-radio-button label="right">右对齐</el-radio-button>
              </el-radio-group>
            </el-form-item>
        ) : null
        const componentRender = {
            // 辅助型组件
            INPUT: [__vModel__, label, placeholder, span, defaultValue, slotPrepend, slotAppend, maxlength, showLabel, showWordLimit, clearable, readonly, required, validateRules, regular, errorMessage, mobileCopy, isUnique, isDesensitization, desensitizationRule, customDesensitizationConf, isDataBaseDesensitization ],
            SELECT_V2: [ __vModel__, label, placeholder, span, defaultValue, options, showLabel, clearable, multiple, required, isUnique ],
            TEXTAREA: [__vModel__, label, placeholder, span, defaultValue, minRows, maxRows, maxlength, showLabel, showWordLimit, clearable, readonly, required, validateRules, regular, errorMessage, mobileCopy, isUnique, isDesensitization, desensitizationRule, customDesensitizationConf, isDataBaseDesensitization],
            PASSWORD: [__vModel__, label, placeholder, span, defaultValue, maxlength, showLabel, clearable, required, mobileCopy, isUnique],
            NUMBER_INPUT: [__vModel__, label, placeholder, span, defaultValue, min, max, step, precision, controlsPosition, showLabel, stepStrictly, required, isUnique],
            TINYMCE: [__vModel__, label, placeholder, span, defaultValue, showLabel, required, isUnique],
            DESC_TEXT: [__vModel__, label, placeholder, span, defaultValue, textAlign, isUnique],
            DIVIDER: [__vModel__, span],
            SIGN_PAD: [__vModel__, label, span, required],
            Duration: [__vModel__, label, placeholder, span, required, isUnique ],
            ENCRYPTINPUT: [__vModel__, label, placeholder, span, required, isUnique, encryptWord, encryptRule],
            // 进阶型组件
            OrgTreeSelect: [__vModel__, label, placeholder, span, showLabel, clearable, multiple, required, isUnique],
            "org-user-picker": [__vModel__, label, placeholder, span, showLabel, multiple, required, isUnique, maxSelect], 
            ByDictSelect: [__vModel__, label, placeholder, span, showLabel, multiple, required, isUnique, dictType],
            CASCADER_V2: [__vModel__, label, placeholder, span, cascaderOption, showLabel, multiple, showAllLevels, filterable, clearable, required, isUnique, ],
            RADIO: [__vModel__, label, placeholder, span, slotOptions, showLabel, required, isUnique],
            CHECKBOX: [__vModel__, label, placeholder, span, slotOptions, showLabel, required, isUnique],
            SWITCH: [__vModel__, label, placeholder, span, activeText, inactiveText, showLabel, required, isUnique],
            SLIDER: [__vModel__, label, placeholder, span, min, max, step, showLabel, showStops, range, required, isUnique],
            TIME: [__vModel__, label, placeholder, span, pickerOptions, format, showLabel, clearable, required, isUnique],
            TIME_RANGE: [__vModel__, label, startPlaceholder, endPlaceholder, span, rangeSeparator, format, showLabel, clearable, required, isUnique],
            DATE: [__vModel__, label, placeholder, span, dateType, format, showLabel, clearable, required, isUnique],
            DATE_RANGE: [__vModel__, label, startPlaceholder, endPlaceholder, span, dateType, rangeSeparator, format, showLabel, clearable, required, isUnique],
            RATE: [__vModel__, label, startPlaceholder, endPlaceholder, span, defaultValue, max, showLabel, allowHalf, showText, showScore, required, isUnique],
            UPLOAD: [__vModel__, label, span, fileSize, uploadApi, buttonText, showLabel, showTip, multiple, limit, required, isUnique],
            Table_List: [__vModel__, label, span, showLabel, isUnique],
            DATE_CALCULATE: [__vModel__, label, placeholder, span, showLabel, required, isUnique, calculate, unit],
            Feedback: [__vModel__, label, placeholder, span, showLabel, FeedbackOptions, required, isUnique],
            CODE: [__vModel__, label, placeholder, span, showLabel, inputReadonly, codeRules],
            DESIGN_SUBTABLE: [__vModel__, label, span, showLabel, isUnique, eventCode, viewCode, isCascader],
            // 系统组件
            ID: [label, span, isUnique],
            CREATE_BY: [label, span, isUnique],
            CREATE_TIME: [label, span, isUnique],
            UPDATE_BY: [label, span, isUnique],
            UPDATE_TIME: [label, span, isUnique],
            DEPT_CODE: [label, span, isUnique],
            // 扩展型组件
            PROVINCE_CITY: [__vModel__, label, placeholder, span, showLabel, required, isUnique],
            INPUT_MAP: [__vModel__, label, placeholder, span, showLabel, required, isUnique],
            AREA_CODE: [__vModel__, label, placeholder, span, showLabel, checkStrictly, rangeArr, multiple, showAllLevels, filterable, required, isUnique],
            Mars3dPicker: [__vModel__, label, placeholder, span, showLabel, appSaasUrl],
            // 业务型组件
            TREE_RELATION: [span, required, isUnique, viewCode, nameField('father'), descField('father')],
            BIZ_RELATION: [__vModel__, label, placeholder, span, showLabel, clearable, multiple, required, isUnique, eventCode, viewCode, idField, nameField('relation'), descField('relation'), isAssignment, assignmentType],
            TASK_FORM: [label, span, isUnique, taskFormMore, eventCode, startViewCode, writeViewCode, taskCode, taskName, previewBtnName, fillBtnName],
            INPUT_COMPUTED: [__vModel__, label, placeholder, span, defaultValue, showLabel, clearable, required, isUnique, computedLabel, computedDialog],
            // 布局型组件
            CARD: [__vModel__, label, placeholder, span, propsTitle('卡片标题'), shadow],
            TABS: [__vModel__, label, placeholder, span, tabsType, tabPosition, tabConfig],
            COLLAPSE: [__vModel__, label, placeholder, span, accordion, tabConfig],
            GROUP_TITLE: [__vModel__, placeholder, span, propsTitle('分组标题'), titlePosition]
        }
        const typeId = this.activeData.typeId
        const children = componentRender[typeId]

        //显隐回调
        const setRules = rules => {
            this.$emit('setRules', rules)
        }
        const uploadDataAction = () => {
            const { api } = this.$attrs.option
            const { uploadData } = api
            if(uploadData) {
                const [ action ] = getAction(uploadData)
                return action()
            } else {
                return ''
            }
        }
        return (
            <div class="right-board">
                <el-tabs v-model={this.currentTab} class="center-tabs" style="height: 100%; overflow-y: scroll">
                    <el-tab-pane label="组件属性" name="field">
                        <el-scrollbar class="right-scrollbar">
                            {
                                h('el-form', { props: { labelWidth: '90px', size: 'small' } }, children)
                            }
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="表单属性" name="form">
                        <el-form label-width="90px" size="small" style="padding: 10px 0">
                            <el-form-item label="显隐规则">
                                <el-button plain onClick={ () => this.rulesDialogVisible = true }>{this.form.rules?.length ? '已设置' : '设置'}</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
                {/* 显隐规则 */}
                <RulesDialog v-model={this.rulesDialogVisible} onSetRules={rules => setRules(rules)} formRules={this.form.rules} formItems={this.form.design.formItems} />
                {/* 计算组件弹框 */}
                <ComputeDialog 
                    v-model={this.showComputeDialog}
                    operator={activeData.calculationRules? 
                        JSON.parse( JSON.stringify(activeData.calculationRules.operator) ) : [{ label: '', value: '', operator: '', next: ''}]
                    } 
                    onConfirm={calculationRules => setCalculationRules(calculationRules)} 
                    allFormItem={allFormItem}
                />
                {/* 赋值规则弹框 */}
                <AssignmentDialog 
                    v-model={this.assignmentDialogVisible}
                    bizAssignmentRules={activeData.bizAssignmentRules}
                    bizFieldList={this.voluationList}
                    formList={allFormItem}
                    onConfirm={bizAssignmentRules => setBizAssignmentRules(bizAssignmentRules)}
                />
                {/* 上传按钮 jsx写法on-success有问题 暂时用h函数 */}
                {
                    h('el-upload', {
                        ref: 'upload',
                        style: { display: 'none' },
                        props: {
                            action: uploadDataAction(),
                            'show-file-list': false,
                            accept: '.xlsx',
                            'on-success': (res) => {
                                if(res.code === 200) {
                                    const data = res.data
                                    if(data.result) {
                                        if (typeId === "SELECT_V2") {
                                            activeData.options = data.result
                                        } else {
                                            activeData.__slot__.options = data.result
                                        }
                                    }
                                }
                            }
                        },
                    }, [
                        h('el-button', {
                        props: {
                            size: 'small',
                            type: 'primary'
                        }
                        }, '点击上传')
                    ])
                }
                {/* 级联添加选项弹框 */}
                <TreeNodeDialog
                    v-model={this.treeNodeDialogVisible}
                    formData={this.cascaderData}
                    isData={activeData.isData}
                    title="选项"
                    onCommit={addNode}
                />
            </div>
        )
    }
}
</script>
<style lang="scss" scoped>
.right-board {
  width: 340px;
  height: 100%;
  padding-top: 3px;
  background-color: #fff;

  .field-box {
    position: relative;
    height: calc(100% - 42px);
    box-sizing: border-box;
    overflow-y: auto;
  }
}

.select-item {
  display: flex;
  border: 1px dashed #fff;
  box-sizing: border-box;
  align-items: center;

  & .close-btn {
    cursor: pointer;
    color: #f56c6c;
  }

  & .el-input + .el-input {
    margin-left: 4px;
  }
}

.select-item + .select-item {
  margin-top: 4px;
}

.select-item.sortable-chosen {
  border: 1px dashed #409eff;
}

.select-line-icon {
  line-height: 32px;
  font-size: 22px;
  padding: 0 4px;
  color: #777;
}

.option-drag {
  cursor: move;
}

.time-range {
  .el-date-editor {
    width: 227px;
  }

  ::v-deep .el-icon-time {
    display: none;
  }
}

.node-label {
  font-size: 14px;
}

.node-icon {
  color: #bebfc3;
}

/* Set the width to 100% */
.width-full {
  width: 100% !important;
}

.flex-row {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
}

::v-deep .custom-tree-node span:first-child {
  display: inline-block;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>